export var appextconfig = {
    "subs_api_url": 'https://subsapiprod.sgiwebservices.com/subscription',
    "csa_submit": {
        "recordType": "01237000000g1Hb",
        "application": "Spotify",
        "external": "1",
        "csa_url": "https://webto.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8",
        "csa_org_id": "00D37000000Ha3W"
    },
    "api_gateway_url": "https://supportapigtwy.continuitysubs.com/prod",
    "api_key": "daW9u77xFC8Ik7iSY1ZB57WbGlDThcrb8C4u8z9N",
    "api_timeout_limit": 15000,//15 seconds
    "api_retry_limit": 3,
    "client_details": {
        "spotifyintegrator":{
            "large_src":"assets/images/logo_spotify_lg.png",
            "large_alt":"Spotify logo",
            "small_src": "assets/images/logo_spotify.png",
            "small_alt": "Spotify logo",
            "cancel_status_cd": 3400,
            "cancel_reason": "Customer Cancel through Self Service"
        },
        'creativebugintegrator':{
            "large_src": "assets/images/logo_creativebug_lg.png",
            "large_alt": "CreativeBug logo",
            "small_src": "assets/images/logo_creativebug.png",
            "small_alt": "CreativeBug logo",
            "cancel_status_cd": 3090,
            "cancel_reason": "Customer Cancel through Self Service"
        },
        '4yourhealth':{
            "large_src": "assets/images/logo_4yh.png",
            "large_alt": "4 Your Health logo",
            "small_src": "assets/images/logo_4yh.png",
            "small_alt": "4 Your Health logo",
            "cancel_status_cd": 3090,
            "cancel_reason": "Customer Cancel through Self Service"
        },
        'stopbreathethink':{
            "large_src": "assets/images/logo_sbt.png",
            "large_alt": "Stop Breathe Think logo",
            "small_src": "assets/images/logo_sbt.png",
            "small_alt": "Stop Breathe Think logo",
            "cancel_status_cd": 3090,
            "cancel_reason": "Customer Cancel through Self Service"
        },
        'tlfc': {
            "large_src": "assets/images/logo_tlfc.png",
            "large_large_alt": "Travel and Leisure Family Club logo",
            "small_src": "assets/images/logo_tlfc.png",
            "small_alt": "Travel and Leisure Family Club logo",
            "cancel_status_cd": 3090,
            "cancel_reason": "Customer Cancel through Self Service"
        },
        'descuentos': {
            "large_src": "assets/images/logo_descuentos.png",
            "large_alt": "Descuentos y Mas logo",
            "small_src": "assets/images/logo_descuentos.png",
            "small_alt": "Descuentos y Mas logo",
            "cancel_status_cd": 3090,
            "cancel_reason": "Customer Cancel through Self Service"
        },
        "foodnwine":{
            "contact_num": "1-800-203-6597",
            "contact_email": "contactus@theconnoisseurclub.com",
            "cancel_status_cd": 3090,
            "cancel_reason": "Customer Cancel through Self Service"
        },
        "golf": {
            "contact_num":"1-800-204-6940",
            "contact_email":"contactus@golfplayersclub.com",
            "cancel_status_cd": 3090,
            "cancel_reason": "Customer Cancel through Self Service"
        },
        "skyguide": {
            "contact_num": "1-800-365-4357",
            "contact_email": "contactus@skyguideclub.com",
            "cancel_status_cd": 3090,
            "cancel_reason": "Customer Cancel through Self Service"
        },
        "elite": {
            "contact_num": "1-800-214-0039",
            "contact_email": "contactus@tlelitetraveler.com",
            "cancel_status_cd": 3090,
            "cancel_reason": "Customer Cancel through Self Service"
        }
    }
}



// WEBPACK FOOTER //
// /home1/jenkins/jobs/SUPPORTCS_AJS_PROD/workspace/src/app/config/app-extconfig-prod.ts